import { TRootState } from "Redux/Reducers";

export const getLocation = (id: string) => (state: TRootState) => state.location.entries[id];
